module.exports = __webpack_public_path__ + "static/media/clown-fish.3d628643.svg";